import { animateTo, shimKeyframesHeightAuto, stopAnimations } from './animation';

class Accordion extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.summary.nextElementSibling;

    this.animating = false;
    this.transitionOpacity = false;
    this.showAnimation = {
      keyframes: [
        { height: '0', ...(this.transitionOpacity && { opacity: '0' }) },
        { height: 'auto', ...(this.transitionOpacity && { opacity: '1' }) },
      ],
      options: { duration: 400, easing: 'ease-in-out' },
    };

    this.hideAnimation = {
      keyframes: [
        { height: 'auto', ...(this.transitionOpacity && { opacity: '1' }) },
        { height: '0', ...(this.transitionOpacity && { opacity: '0' }) },
      ],
      options: { duration: 400, easing: 'ease-in-out' },
    };
  }

  connectedCallback() {
    this.summary.addEventListener('click', this.handleClick.bind(this));
  }

  disconnectedCallback() {
    this.summary.removeEventListener('click', this.handleClick);
  }

  // watch for closing attribute
  static get observedAttributes() {
    return ['will-close'];
  }

  attributeChangedCallback(name, _, newValue) {
    if (name === 'will-close' && newValue !== null) {
      this.toggle(false);
    }
  }

  async handleClick(e) {
    e.preventDefault();

    if (this.animating) await stopAnimations(this.content);
    this.toggle(!this.details.open);
  }

  async toggle(open) {
    this.dispatchEvent(new CustomEvent(`accordion:${open ? 'open' : 'close'}`, { bubbles: true }));
    this.details.style.overflow = 'hidden';
    if (open) {
      this.details.open = open;
      this.details.classList.add('opening');
    } else {
      this.details.classList.add('closing');
      this.details.classList.remove('open');
    }

    this.animating = true;
    const animation = open ? await this.showAnimation : this.hideAnimation;
    const { keyframes, options } = animation;

    try {
      await animateTo(this.content, shimKeyframesHeightAuto(keyframes, this.content.scrollHeight), options);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    } finally {
      this.animating = false;
      this.details.open = open;
      this.details.style.height = '';
      this.details.style.overflow = '';
      this.details.classList.remove('opening', 'closing', 'open');
      this.details.classList.toggle('open', open);
    }
  }
}

customElements.define('domaine-accordion', Accordion);
